// extracted by mini-css-extract-plugin
export default {"root":"FavoriteButton_root__17Akw","saved":"FavoriteButton_saved__AnHST"};